import {
  Wrench,
  AlertTriangle,
  Hammer,
  SearchCheck,
  PencilRuler,
  StickyNote,
} from "lucide-react";

export const MACHINE_STATUSES = [
  { value: "operativa", label: "Operativa" },
  { value: "mantenimiento", label: "En mantenimiento" },
  { value: "fuera_servicio", label: "Fuera de servicio" },
];

export const STATUS_LABEL = Object.fromEntries(
  MACHINE_STATUSES.map((s) => [s.value, s.label])
);

export const STATUS_STYLES = {
  operativa: {
    dot: "bg-emerald-500",
    badge: "bg-emerald-50 text-emerald-700 border border-emerald-200/70",
  },
  mantenimiento: {
    dot: "bg-amber-500",
    badge: "bg-amber-50 text-amber-700 border border-amber-200/70",
  },
  fuera_servicio: {
    dot: "bg-rose-500",
    badge: "bg-rose-50 text-rose-700 border border-rose-200/70",
  },
};

export const DOC_TYPES = [
  { value: "manual", label: "Manual" },
  { value: "esquema", label: "Esquema eléctrico" },
  { value: "ficha", label: "Ficha técnica" },
  { value: "certificado", label: "Certificado" },
  { value: "mantenimiento", label: "Mantenimiento" },
  { value: "otros", label: "Otros" },
];

export const DOC_TYPE_LABEL = Object.fromEntries(
  DOC_TYPES.map((t) => [t.value, t.label])
);

export const INTERVENTION_TYPES = [
  { value: "mantenimiento", label: "Mantenimiento", icon: Wrench, classes: "bg-zinc-100 text-zinc-700" },
  { value: "averia", label: "Avería", icon: AlertTriangle, classes: "bg-rose-50 text-rose-600" },
  { value: "reparacion", label: "Reparación", icon: Hammer, classes: "bg-blue-50 text-blue-600" },
  { value: "inspeccion", label: "Inspección", icon: SearchCheck, classes: "bg-emerald-50 text-emerald-600" },
  { value: "modificacion", label: "Modificación", icon: PencilRuler, classes: "bg-violet-50 text-violet-600" },
  { value: "nota", label: "Nota", icon: StickyNote, classes: "bg-zinc-100 text-zinc-600" },
];

export const INTERVENTION_MAP = Object.fromEntries(
  INTERVENTION_TYPES.map((t) => [t.value, t])
);

export const fileExtension = (name = "") => {
  const parts = name.split(".");
  return parts.length > 1 ? parts.pop().toUpperCase() : "";
};
